import { type DocumentNode, gql } from '@apollo/client';

const deleteWholeCollection: DocumentNode = gql`
  mutation deleteWholeCollection($collectionId: ID!) {
    deleteCollection(collectionId: $collectionId) {
      collection {
        name
      }
    }
  }
`;

export default deleteWholeCollection;
